// extracted by mini-css-extract-plugin
export var collapse_arrow = "index-module--collapse_arrow--9ecc7";
export var collapse_arrow_active = "index-module--collapse_arrow_active--5244b";
export var content = "index-module--content--e19ee";
export var title = "index-module--title--d6ec8";